import React from "react";
import i18n, { Ti18nKeys } from "../../../constants/i18n";
import Et3PageTitle from "../../../core/et3-page-title/index";
import getCoreHistoryStore from "../../../stores/core/core-history-store";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import ET3PageDiv from "../../../core/et3-page-div";
import GiveSubscriptionsForm from "./give-subscriptions-form";
import UserSetSubscriptions from "./user-set-subscriptions-form";
import ET3Div from "../../../core/et3-div";
import Et3Margin from "../../../core/et3-ui/ET3Margin";
import Et3Text from "../../../core/et3-text";
import { TSubscriptionType } from "../../../Types";

const SubscriptionSection = withLiteObserverAndTheme<{
  title: Ti18nKeys;
  subtitle: Ti18nKeys;
  types: TSubscriptionType[];
}>((props) => {
  const { title, subtitle, types, theme } = props;
  const { colors } = theme;

  return (
    <ET3Div
      width={1500}
      height={50}
      alignItems={"flex-start"}
      fDirection={"column"}
      style={{}}
      color={colors.all.transparent}
      justifyContent={"flex-start"}
      withShadow={false}
      isExtendable={true}
      isScrollable={false}
      onClick={() => {}}
    >
      <ET3Div
        width={1500}
        height={28}
        alignItems={"flex-end"}
        fDirection={"row"}
        style={{}}
        color={colors.all.transparent}
        justifyContent={"flex-start"}
        withShadow={false}
        isExtendable={false}
        isScrollable={false}
        onClick={() => {}}
      >
        <Et3Text
          text={i18n.get(title)}
          fontFamily="BOLD"
          fontSize={19}
          color={colors.all.maastrichtBlue}
          isSpan={true}
          style={{}}
        />
        <Et3Text
          text={i18n.get(subtitle)}
          fontFamily="LIGHT"
          fontSize={13}
          color={colors.all.dimGray}
          isSpan={true}
          style={{ marginLeft: 12 }}
        />
      </ET3Div>
      <Et3Margin top={10} bottom={0} left={0} right={0} />
      <ET3Div
        width={1500}
        height={2}
        alignItems={"center"}
        fDirection={"row"}
        style={{ borderRadius: 2 }}
        color={colors.all.paleBluishGray}
        justifyContent={"flex-start"}
        withShadow={false}
        isExtendable={false}
        isScrollable={false}
        onClick={() => {}}
      />
      <Et3Margin top={28} bottom={0} left={0} right={0} />
      <ET3Div
        width={1500}
        height={300}
        alignItems={"flex-start"}
        fDirection={"row"}
        style={{ flexWrap: "wrap", columnGap: 60, rowGap: 45 }}
        color={colors.all.transparent}
        justifyContent={"flex-start"}
        withShadow={false}
        isExtendable={true}
        isScrollable={false}
        onClick={() => {}}
      >
        {types.map((type) => (
          <UserSetSubscriptions key={type} subscriptionType={type} />
        ))}
      </ET3Div>
    </ET3Div>
  );
});

const GiveSubscriptions = withLiteObserverAndTheme(() => {
  React.useEffect(() => {
    getCoreHistoryStore().setPageName(
      "SCSR_GIVE_SUBSCRIPTIONS",
      "SCSR_GIVE_SUBSCRIPTIONS"
    );
  }, []);

  return (
    <ET3PageDiv
      fDirection="column"
      alignItems="flex-start"
      justifyContent="flex-start"
      style={{}}
    >
      <Et3PageTitle
        title={i18n.get("GIVE_SUBSCRIPTIONS")}
        subTitle={i18n.get("GIVE_SUBSCRIPTIONS")}
        withRefresh={false}
        withHelper={false}
        onPress={() => {}}
      />
      <GiveSubscriptionsForm />
      <Et3Margin top={55} bottom={0} left={0} right={0} />
      <SubscriptionSection
        title="SUBSCRIPTION_SECTION_LEGACY_TITLE"
        subtitle="SUBSCRIPTION_SECTION_LEGACY_SUBTITLE"
        types={["VIP", "PLUS"]}
      />
      <Et3Margin top={55} bottom={0} left={0} right={0} />
      <SubscriptionSection
        title="SUBSCRIPTION_SECTION_TIERS_TITLE"
        subtitle="SUBSCRIPTION_SECTION_TIERS_SUBTITLE"
        types={["SILVER", "GOLD", "PLATINUM", "BLACK"]}
      />
      <Et3Margin top={55} bottom={0} left={0} right={0} />
      <SubscriptionSection
        title="SUBSCRIPTION_SECTION_REFERRAL_TITLE"
        subtitle="SUBSCRIPTION_SECTION_REFERRAL_SUBTITLE"
        types={["ADVANCED"]}
      />
      <Et3Margin top={55} bottom={0} left={0} right={0} />
      <SubscriptionSection
        title="SUBSCRIPTION_SECTION_KHATTABAT_TITLE"
        subtitle="SUBSCRIPTION_SECTION_KHATTABAT_SUBTITLE"
        types={["ALKHATTABAT"]}
      />
    </ET3PageDiv>
  );
});
export default GiveSubscriptions;
